<div class="zag-collection-layout-controls">
  <!-- View Mode Toggle: horizontal pill-switch -->
  @if (showViewModes()) {
    <div class="zag-collection-layout-controls__view-card">
      <span class="zag-collection-layout-controls__card-label">{{ 'common.viewMode' | translate }}</span>
      <zag-button-group
        [options]="viewModeButtonOptions()"
        [(value)]="viewMode"
        orientation="horizontal"
        [iconOnly]="true"
        [ariaLabel]="'common.viewMode' | translate"
      />
    </div>
  }

  <!-- Filter groups -->
  @if (showFilter()) {
    @for (group of translatedFilterGroups(); track group.id) {
      <div class="zag-collection-layout-controls__sort-card">
        <div class="zag-collection-layout-controls__filter-header">
          <span class="zag-collection-layout-controls__card-label">{{ group.label }}</span>
          @if (hasSelectedFilters(group.id)) {
            <button
              zagButton="basic"
              zagType="secondary"
              zagSize="sm"
              type="button"
              class="zag-collection-layout-controls__filter-clear-btn"
              [attr.aria-label]="group.clearLabel ?? ('common.clear' | translate)"
              [attr.title]="group.clearLabel ?? ('common.clear' | translate)"
              (click)="clearFilterGroup($event, group.id)"
            >
              <span zagIcon="filter_list_off" aria-hidden="true"></span>
            </button>
          }
        </div>
        <fieldset zagFieldset class="zag-collection-layout-controls__sort-list" [attr.aria-label]="group.label">
          <span slot="legend" class="zag-sr-only">{{ group.label }}</span>
          <div class="zag-collection-layout-controls__sort-list-content">
            @for (option of group.options; track option.value) {
              <button
                type="button"
                class="zag-collection-layout-controls__sort-item"
                [class.zag-collection-layout-controls__sort-item--active]="isFilterSelected(group.id, option.value)"
                [attr.aria-pressed]="isFilterSelected(group.id, option.value)"
                (click)="toggleFilter(group.id, option.value, group.allowMultiple)"
              >
                @if (option.icon) {
                  <span [zagIcon]="option.icon" class="zag-collection-layout-controls__sort-icon" aria-hidden="true"></span>
                }
                <span class="zag-collection-layout-controls__sort-label">{{ option.label }}</span>
              </button>
            }
          </div>
        </fieldset>
      </div>
    }
  }

  <!-- Sort: flat list card (no header, direction toggle per active option) -->
  @if (showSort()) {
    <div class="zag-collection-layout-controls__sort-card">
      <fieldset zagFieldset class="zag-collection-layout-controls__sort-list" [attr.aria-label]="'common.sort' | translate">
        <span slot="legend" class="zag-sr-only">{{ 'common.sort' | translate }}</span>
        <div class="zag-collection-layout-controls__sort-list-content">
          @for (option of translatedSortOptions(); track option.id) {
            <button
              type="button"
              class="zag-collection-layout-controls__sort-row"
              [class.zag-collection-layout-controls__sort-row--active]="sortBy() === option.id"
              [attr.aria-pressed]="sortBy() === option.id"
              (click)="sortBy() === option.id ? toggleSortDirection($event) : selectSort(option.id)"
            >
              <span class="zag-collection-layout-controls__sort-label">
                @if (option.icon) {
                  <span [zagIcon]="option.icon" class="zag-collection-layout-controls__sort-icon" aria-hidden="true"></span>
                }
                <span class="zag-collection-layout-controls__sort-text">{{ option.label }}</span>
              </span>
              <span
                class="zag-collection-layout-controls__sort-direction"
                [class.selected]="sortBy() === option.id"
                [zagIcon]="sortDirectionIcon()"
                aria-hidden="true"
              >
              </span>
            </button>
          }
        </div>
      </fieldset>
    </div>
  }
</div>
